import { type ChangeEvent } from 'react'

import {
  VirtualTerminalProxyFormFieldNamesEnum
} from '../../../../../../shared/types/virtualTerminalProxyFormFieldNamesEnum'
import { virtualTerminalProxy } from '../../virtualTerminalProxy'
import { addToArray, removeFromArray } from '../../../../../../shared/utils/arrayUtils'
import { CardAddFormFieldNamesEnum } from '../../../../../../shared/components/CardAddSlideOver/cardAddFormFieldNamesEnum'
import { validators } from './validators'
import { normalizers } from './normalizers'

export const BORDER_COLOR = 'border-wpy-blue-gray-100'

export const handleChange = (fieldName: VirtualTerminalProxyFormFieldNamesEnum) => (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
  // @ts-expect-error
  const val: string = e.target.type === 'checkbox' ? e.target.checked : e.target.value
  const normalizer = normalizers[fieldName]
  const normalized = normalizer ? normalizer(val) : val
  virtualTerminalProxy.form.values[fieldName] = normalized
  virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, fieldName)
  const validator = validators[fieldName]
  if (validator) { virtualTerminalProxy.form.errors[fieldName] = validator(normalized) }
}

export const handleBlur = (fieldName: VirtualTerminalProxyFormFieldNamesEnum) => () => {
  virtualTerminalProxy.form.blurred = addToArray(virtualTerminalProxy.form.blurred, fieldName)
}

export function populateServiceAddressInfoFromCustomer (): void {
  const customer = virtualTerminalProxy.customer
  if (customer) {
    virtualTerminalProxy.form.values.streetAddressOne = customer.addressOne
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.StreetAddressOne)

    if (customer.addressTwo) {
      virtualTerminalProxy.form.values.streetAddressTwo = customer.addressTwo
      virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.StreetAddressTwo)
    }

    virtualTerminalProxy.form.values.city = customer.city
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.City)

    virtualTerminalProxy.form.values.state = customer.state
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.State)

    virtualTerminalProxy.form.values.postalCode = customer.postalCode
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.PostalCode)

    virtualTerminalProxy.form.values.countryCode = customer.countryCode
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.CountryCode)

    virtualTerminalProxy.form.values.email = customer.email
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, CardAddFormFieldNamesEnum.Email)
  }
}

export function clearServiceAddressInformationForCustomer (): void {
  virtualTerminalProxy.form.values.streetAddressOne = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.StreetAddressOne)

  virtualTerminalProxy.form.values.streetAddressTwo = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.StreetAddressTwo)

  virtualTerminalProxy.form.values.city = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.City)

  virtualTerminalProxy.form.values.state = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.State)

  virtualTerminalProxy.form.values.postalCode = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.PostalCode)

  virtualTerminalProxy.form.values.countryCode = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.CountryCode)

  virtualTerminalProxy.form.values.email = null
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.Email)
}
